import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Save, X } from 'lucide-react';

const EMPTY = {
  title: '',
  description: '',
  youtube_id: '',
  category: 'Confidence',
  duration_seconds: 600,
  tier_min: 'free',
  sort_order: 100,
};

export { EMPTY as EMPTY_VIDEO };

export default function AdminVideoFormRow({ initial, onCancel, onSubmit, busy, isCreate }) {
  const [form, setForm] = useState(initial || EMPTY);
  const setField = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-[1fr_180px_120px_120px_120px_auto] gap-2 p-3 bg-[#F6F7F8] rounded-lg border border-border">
      <Input
        placeholder="Title"
        value={form.title}
        onChange={(e) => setField('title', e.target.value)}
        data-testid="admin-video-title"
      />
      <Input
        placeholder="YouTube ID or URL"
        value={form.youtube_id}
        onChange={(e) => setField('youtube_id', e.target.value)}
        data-testid="admin-video-youtube"
      />
      <Input
        placeholder="Category"
        value={form.category}
        onChange={(e) => setField('category', e.target.value)}
        data-testid="admin-video-category"
      />
      <Input
        type="number"
        placeholder="Sec"
        value={form.duration_seconds}
        onChange={(e) => setField('duration_seconds', Number(e.target.value) || 0)}
        data-testid="admin-video-duration"
      />
      <Select value={form.tier_min} onValueChange={(v) => setField('tier_min', v)}>
        <SelectTrigger data-testid="admin-video-tier"><SelectValue placeholder="Tier" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="free">Free</SelectItem>
          <SelectItem value="pro">Pro</SelectItem>
          <SelectItem value="premium">Premium</SelectItem>
        </SelectContent>
      </Select>
      <div className="flex gap-1.5">
        <Button
          type="button"
          onClick={() => onSubmit(form)}
          disabled={busy}
          className="bg-[#004C54] hover:bg-[#003a40] text-white"
          data-testid={isCreate ? 'admin-video-create-submit' : 'admin-video-save-submit'}
        >
          <Save className="h-3.5 w-3.5 mr-1" /> {isCreate ? 'Add' : 'Save'}
        </Button>
        <Button type="button" variant="outline" onClick={onCancel} data-testid="admin-video-cancel">
          <X className="h-3.5 w-3.5" />
        </Button>
      </div>
      <Textarea
        className="md:col-span-6"
        placeholder="Description"
        value={form.description}
        onChange={(e) => setField('description', e.target.value)}
        rows={2}
        data-testid="admin-video-description"
      />
    </div>
  );
}
